import { create } from "zustand"
import { LocationListResponse, Location } from "../Models/LocationListResponse"
import { arraysEqual } from "../Utils/arrayUtils"
import api from "../Api/Api"

interface LocationsState {
  locations: Location[]
  countryNames: string
  countryIds: string[]
  loading: boolean
  error: string | null
  targetLocationId: string | null
  setTargetLocationId: (targetLocationId: string | null) => void

  setCountryIds: (countryIds: string[]) => void
  fetchLocations: (countryIds: string[]) => Promise<void>
  resetState: () => void
}

const useLocationsStore = create<LocationsState>((set, get) => ({
  locations: [],
  countryNames: "",
  countryIds: [],
  loading: false,
  error: null,
  targetLocationId: null,
  setTargetLocationId: (targetLocationId: string | null) => {
    set({ targetLocationId })
  },

  setCountryIds: (countryIds: string[]) => {
    // If there's a change in countryIds, fetch locations
    if (!arraysEqual(countryIds, get().countryIds)) {
      get().fetchLocations(countryIds)
    }
    set({ countryIds })
  },

  fetchLocations: async (countryIds: string[]) => {
    if (!countryIds || countryIds.length === 0) {
      return
    }

    try {
      set({ loading: true, error: null })

      const queryParams = countryIds.map(id => `countryIds=${id}`).join("&")
      const response = await api.get<LocationListResponse>(
        `/location/top?${queryParams}`
      )

      if (response.status !== 200) {
        throw new Error("Failed to fetch locations")
      }

      const data: LocationListResponse = response.data

      set({
        locations: data.locations,
        countryNames: data.countryNames,
        loading: false
      })
    } catch (error) {
      console.error("Error fetching locations:", error)
      set({
        error: "Failed to load locations. Please try again.",
        loading: false
      })
    }
  },

  resetState: () => {
    set({
      locations: [],
      countryNames: "",
      countryIds: [],
      loading: false,
      error: null
    })
  }
}))

export default useLocationsStore
